import { AwsUi } from '../../../core/runtime/src';
import BemClassBuilder from '../../../core/utils/src/class-builders/bem';
import { RadioButton } from './radio-button';
import { RadioGroupController } from './controller';
import { generateGroupName } from './utils';
export var Tiles = AwsUi.__addComponent('awsui-tiles', {
    releaseStatus: 'stable',
    callbacks: {
        initialized: function () {
            this.__controller = new RadioGroupController(this, this.node);
            this.__name = generateGroupName(this.__componentName);
        }
    },
    events: {
        // Fired when the user selects an unselected tile.
        // The event `detail` contains the current `value`.
        change: {
            bubbles: true,
            cancelable: false,
            detailType: 'Tiles.ChangeDetail'
        }
    },
    properties: {
        // Value of the selected tile.
        value: {
            type: 'string',
            onChange: function () {
                this.__controller.handleValueChange();
            }
        },
        // List of tile definitions.
        //
        // Each tile has the following properties (only `value` and `label` are mandatory):
        // * `value` [string]: The value that will be associated with the tile.
        // * `label` [Renderable]: Short description for the option the tile represents.
        // * `description` [Renderable]: Further explanatory guidance on the tile option, shown below the `label`.
        // * `image` [Renderable]: Visually distinctive image for the tile option, shown below the `description`. `img` tags in this `Renderable` are styled automatically.
        // * `disabled` [boolean]: Whether the tile is disabled. Disabled tiles can not be selected by the user.
        // * `ariaLabelledby` [string]: Adds `aria-labelledby` on the native input. Use this with form fields that contain multiple controls under the same label.
        //    When used outside of form fields, wrap the tiles into a `div` with `role=radiogroup`, set its `aria-label` and `id` attributes and use its `id` to set the `ariaLabelledby` property of each tile.
        // * `ariaLabel` [string]: Adds an `aria-label` to the native input. Only use this when you do not have a visible label for this control.
        // * `ariaDescribedby` [string]: Adds `aria-describedby` on the native input. Use this only with `form fields` that contain multiple controls under the same label.
        // * `controlId` [string]: The id of the internal input. Useful for relating a "for" attribute of a label to this control.
        //
        // **Renderable value**
        //   * **AngularJS:** Must be a string representing an Angular template.
        //   * **React:** Must be a valid React element or a function that returns a React element to display.
        //     Example: `() => {return (<img src='/logo.png' />);}` or just `<img src='/logo.png' />` in jsx.
        //   * **GWT:** Must be a lambda function that should return either a string, html element or GWT-widget instance.
        //     Example: `() -> 'some text'` or `() -> new HTMLPanel()`.
        items: {
            type: 'array',
            itemTypes: ['Tiles.TileDefinition']
        },
        // Adds aria-required on the group. This will only be applied if the group
        // is wrapped in an awsui-form-field
        ariaRequired: {
            type: 'boolean',
            announceValue: true
        },
        // The number of columns for the tiles to be displayed in.
        // Valid values are integers between 1 and 4.
        // If no value is specified, the number of columns
        //  * is determined based on the number of items, with a maximum of 3.
        //  * is set to 2 if 4 or 8 items are supplied, in order to optimize the layout.
        columns: {
            type: 'integer',
            valid: [1, 2, 3, 4]
        }
    },
    render: function () {
        var _this = this;
        var getColumns = function () {
            if (_this.columns) {
                return _this.columns;
            }
            var nItems = _this.items.length;
            var columnsLookup = {
                0: 1,
                1: 1,
                2: 2,
                4: 2,
                8: 2
            };
            return columnsLookup[nItems] || 3;
        };
        var columns = getColumns();
        var columnsCb = new BemClassBuilder(this, 'columns').modifier("" + columns);
        return (AwsUi.__createElement("div", { className: new BemClassBuilder(this).toString() },
            AwsUi.__createElement("div", { className: columnsCb.toString() }, this.items.map(function (item, index) {
                var controlId = item.controlId || _this.__name + "-value-" + item.value;
                return (AwsUi.__createElement("label", { className: new BemClassBuilder(_this, 'tile-container')
                        .modifier('selected', item.value === _this.value)
                        .modifier('disabled', !!item.disabled)
                        .toString(), for: controlId, id: controlId + "-label" },
                    AwsUi.__createElement("div", { className: new BemClassBuilder(_this, 'control').modifier('no-image', !item.image).toString() },
                        AwsUi.__createElement(RadioButton, { label: _this.renderToMithril("radio-button-label-" + index, item.label), description: item.description
                                ? _this.renderToMithril("radio-button-description-" + index, item.description)
                                : '', __managedByRadioGroup: true, __isTile: true, name: _this.__name, checked: _this.value === item.value, value: item.value, disabled: Boolean(item.disabled), controlId: controlId, ariaLabel: item.ariaLabel, ariaLabelledby: item.ariaLabelledby, ariaDescribedby: item.ariaDescribedby })),
                    item.image && (AwsUi.__createElement("div", { className: new BemClassBuilder(_this, 'image').modifier('disabled', !!item.disabled).toString() }, _this.renderToMithril("radio-button-image-" + index, item.image)))));
            }))));
    }
});
//# sourceMappingURL=tiles.js.map